import React from 'react';

const ContactFields = ({
  oldData, 
  setName,
  setProfession,
  setCity,
  setLivingPlaces,
  setFavoritPlaces
}) => {

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Имя
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.name}
          placeholder='имя'
          onChange={e => { setName(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Работа
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.profession}
          placeholder='работа'
          onChange={e => { setProfession(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Город
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.city}
          placeholder='город'
          onChange={e => { setCity(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Район проживания
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.living_place}
          placeholder='район проживания'
          onChange={e => { setLivingPlaces(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Любимые места в городе
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.favorite_places}
          placeholder='Любимые места в городе'
          onChange={e => { setFavoritPlaces(e) }}
      />

    </>
  );
};

export default ContactFields;